"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../../common/constants/states");
var AdminStudentPickupLocationsController = /** @class */ (function () {
    function AdminStudentPickupLocationsController(UserService, $stateParams, UsersModel, FlashService, LocationsModel, $q, SchoolsModel) {
        var _this = this;
        this.UserService = UserService;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.LocationsModel = LocationsModel;
        this.$q = $q;
        this.SchoolsModel = SchoolsModel;
        this.currentUser = UserService.getCurrentUser();
        this.busy = false;
        this.loading = true;
        this.states = states_1.States;
        this.student = {
            id: this.$stateParams.userId,
        };
        this.resetPickupLocationInServiceArea =
            this.resetPickupLocationInServiceArea.bind(this);
        var getLocations = LocationsModel.getLocations();
        var getPickupLocations = UsersModel.getPickupLocations($stateParams.userId);
        var getSchool = SchoolsModel.getSchoolByID(this.currentUser.school_id);
        this.school = this.currentUser.school;
        var getMap = SchoolsModel.getMap(this.school.id, {
            student_id: $stateParams.userId,
        });
        //this just sets a default center while the pickup addresses load
        this.center = {
            lat: this.school.address.lat,
            lng: this.school.address.lng,
            zoom: 2,
        };
        this.mapLocations = [];
        $q.all([getLocations, getPickupLocations, getSchool, getMap]).then(function (response) {
            var mapData = response[3];
            _this.mapData = response[3];
            _this.locations = mapData.locations;
            _this.school.locations = _this.locations;
            _this.currentUser.school.locations = _this.locations;
            _this.currentUser.school.zones = response[2].zones;
            var data = response[1];
            _this.center = __assign(__assign({}, mapData.center), { zoom: 2 });
            _this.load(data);
        });
    }
    AdminStudentPickupLocationsController.prototype.load = function (response) {
        var _a;
        if (response.pickuplocations.length > 0) {
            this.pickupLocations = response.pickuplocations;
            (_a = this.mapLocations).push.apply(_a, this.pickupLocations);
            this.center = {
                lat: this.pickupLocations[0].address.lat,
                lng: this.pickupLocations[0].address.lng,
                zoom: 2,
            };
        }
        this.loading = false;
    };
    AdminStudentPickupLocationsController.prototype.resetPickupLocationInServiceArea = function () {
        var _this = this;
        this.busy = true;
        this.loading = true;
        this.UsersModel.resetPickupLocationInServiceArea(this.$stateParams.userId)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .then(function () {
            var getLocations = _this.LocationsModel.getLocations();
            var getPickupLocations = _this.UsersModel.getPickupLocations(_this.$stateParams.userId);
            var getSchool = _this.SchoolsModel.getSchoolByID(_this.currentUser.school_id);
            var getMap = _this.SchoolsModel.getMap(_this.school.id, {
                student_id: _this.$stateParams.userId,
            });
            _this.mapLocations = [];
            _this.$q
                .all([getLocations, getPickupLocations, getSchool, getMap])
                .then(function (response) {
                var mapData = response[3];
                _this.mapData = response[3];
                _this.locations = mapData.locations;
                _this.school.locations = _this.locations;
                _this.currentUser.school.locations = _this.locations;
                _this.currentUser.school.zones = response[2].zones;
                var data = response[1];
                _this.center = __assign(__assign({}, mapData.center), { zoom: 2 });
                _this.busy = false;
                _this.load(data);
            });
        })
            .catch(function (Error) {
            _this.busy = false;
            _this.loading = false;
        });
    };
    AdminStudentPickupLocationsController.prototype.removePickupLocation = function (id) {
        var _this = this;
        this.busy = true;
        var data = {
            user_id: this.$stateParams.userId,
            location_id: id,
        };
        this.UsersModel.unattachStudentPickupLocation(data.user_id, data.location_id)
            .then(function (response) {
            var _a;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.pickupLocations = response.pickuplocations.sort(function (a, b) {
                return a.pivot.sequence - b.pivot.sequence;
            });
            _this.mapLocations = [];
            (_a = _this.mapLocations).push.apply(_a, _this.pickupLocations);
            _this.busy = false;
            _this.pickupLocation = _this.pickupLocations[0];
        })
            .catch(function (error) {
            _this.busy = false;
        });
    };
    AdminStudentPickupLocationsController.prototype.updatePickupLocation = function (location) {
        var _this = this;
        this.busy = true;
        this.loading = true;
        var data = Object.assign({}, location);
        data.sequence = location.pivot.sequence;
        this.UsersModel.updatePickUpLocation(this.$stateParams.userId, location.id, data)
            .then(function (response) {
            _this.busy = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .then(function () {
            var getLocations = _this.LocationsModel.getLocations();
            var getPickupLocations = _this.UsersModel.getPickupLocations(_this.$stateParams.userId);
            var getSchool = _this.SchoolsModel.getSchoolByID(_this.currentUser.school_id);
            var getMap = _this.SchoolsModel.getMap(_this.school.id, {
                student_id: _this.$stateParams.userId,
            });
            _this.mapLocations = [];
            _this.$q
                .all([getLocations, getPickupLocations, getSchool, getMap])
                .then(function (response) {
                var mapData = response[3];
                _this.mapData = response[3];
                _this.locations = mapData.locations;
                _this.school.locations = _this.locations;
                _this.currentUser.school.locations = _this.locations;
                _this.currentUser.school.zones = response[2].zones;
                var data = response[1];
                _this.center = __assign(__assign({}, mapData.center), { zoom: 2 });
                _this.busy = false;
                _this.load(data);
            });
        })
            .catch(function (error) {
            _this.busy = false;
        });
    };
    return AdminStudentPickupLocationsController;
}());
AdminStudentPickupLocationsController.$inject = [
    "UserService",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "LocationsModel",
    "$q",
    "SchoolsModel",
];
exports.default = AdminStudentPickupLocationsController;
